import * as React from "react";
import { HeaderLogoAndTel } from "../../../../HeaderLogoAndTel";
import { Modal } from "../../../../Modal";
import * as main from "../../styles/main.module.scss";
import * as screen1 from "./style.module.scss";

export const Screen1 = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={screen1.screen1}>
      <div className={main.containerFluid}>
        <HeaderLogoAndTel logo={"white"} phoneHide={true}/>
        <h1 className={screen1.screen1__title}>
          Индивидуальная подготовка по авторской методике лучшими педагогами Центра&nbsp;Advance
        </h1>
        <p className={screen1.screen1__text}>
          Наши занятия — <b>не репетиторство</b>, <br/>
          мы учим ваших детей учиться <b>без помощи</b> взрослых, <br/>
          самостоятельно думать, ставить и с&nbsp;интересом достигать цели
        </p>
        <button className={`${main.btn} ${screen1.screen1__btn}`} onClick={()=>{setShowModal(true)}}>
          Оставить заявку на звонок менеджера
        </button>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </section>
  );
};
